export enum pd_options {
    "No",
    "Sí, asignación por Desempeño en Condiciones Difíciles",
    "Sí, asignación por Alta Concentración de Alumnos Prioritarios"
}

export enum percentage_options {
    "60% a 80%",
    "80% o más"
}